(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-warning"] && !Shopify.designMode) return;
  try {
    const setProductWarningCartCounts = () => {
    const warnings = document.querySelectorAll('[data-product-warning]');

    warnings.forEach((warning) => {
      const cartCount = warning.querySelector('[data-product-warning-cart-count]');

      if (!cartCount) return;

      const min = Number.parseInt(warning.dataset.cartCountMin, 10) || 7;
      const max = Number.parseInt(warning.dataset.cartCountMax, 10) || 18;
      const low = Math.min(min, max);
      const high = Math.max(min, max);

      const getNextCount = () => {
        const current = Number.parseInt(cartCount.textContent, 10);
        let next = Math.floor(Math.random() * (high - low + 1)) + low;

        if (high > low) {
          while (next === current) {
            next = Math.floor(Math.random() * (high - low + 1)) + low;
          }
        }

        return next;
      };

      cartCount.textContent = getNextCount();

      if (warning.dataset.cartCountInterval) return;

      const interval = window.setInterval(() => {
        cartCount.textContent = getNextCount();
      }, 7000);

      warning.dataset.cartCountInterval = interval;
    });
  };

  document.addEventListener('DOMContentLoaded', setProductWarningCartCounts);
  document.addEventListener('shopify:section:load', setProductWarningCartCounts);
  } catch(e) { console.error(e); }
})();

})();
